const state = {
	connectors: [],
};

const getters = {};
const actions = {
	LoadConnectors({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('connectors.get_all');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						commit("storeConnectors", response.data.connectors);
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
};
const mutations = {
	storeConnectors(state, loaded_connectors){
		console.log(loaded_connectors);
		state.connectors = [];
		for(let i = 0; i < loaded_connectors.length; i++)
		{
			state.connectors.push(loaded_connectors[i]);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
